<template>
  <div class="chapter-section">
    <ChapterSectionLesson
      v-if="sectionType === ChapterSectionType.LESSON"
      :book-id="bookId"
      :chapter-id="chapterId"
      :lesson-id="sectionId"
    />
    <ChapterSectionTrialExam
      v-if="sectionType === ChapterSectionType.TRIAL_EXAM"
      :chapter-id="chapterId"
      :chapter-test-id="sectionId"
    />
  </div>
</template>

<script>
import { getIdFromSlug } from '@/utils/string'

import { ChapterSectionType } from '@/enums'
import ChapterSectionLesson from '@/components/books/ChapterSectionLesson'
import ChapterSectionTrialExam from '@/components/books/ChapterSectionTrialExam'

export default {
  name: 'ChapterSection',
  components: {
    ChapterSectionTrialExam,
    ChapterSectionLesson,
  },
  props: {
    chapterData: {
      type: Object,
      required: true,
    },
    bookSlug: {
      type: String,
      required: true,
    },
    sectionSlug: {
      type: String,
      required: true,
    },
    sectionTypeString: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ChapterSectionType,
    }
  },
  computed: {
    /**
     * @return {number}
     */
    sectionType() {
      return parseInt(this.sectionTypeString)
    },

    /**
     * @return {number}
     */
    bookId() {
      return getIdFromSlug(this.bookSlug)
    },

    /**
     * @return {number}
     */
    chapterId() {
      return this.chapterData.id
    },

    /**
     * @return {number}
     */
    sectionId() {
      return getIdFromSlug(this.sectionSlug)
    },
  },
}
</script>
